(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-zsq-section]').forEach((section) => {
      if (section.dataset.zsqReady === 'true') return;

      section.dataset.zsqReady = 'true';

      const tabs = [...section.querySelectorAll('[data-zsq-tab]')];
      const panels = [...section.querySelectorAll('[data-zsq-panel]')];

      const activate = (name) => {
        tabs.forEach((tab) => {
          const isActive = tab.dataset.zsqTab === name;

          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.zsqPanel === name;

          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          activate(tab.dataset.zsqTab);
        });

        tab.addEventListener('keydown', (event) => {
          if (
            !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
          ) {
            return;
          }

          event.preventDefault();

          let nextIndex = index;

          if (event.key === 'ArrowRight') {
            nextIndex = (index + 1) % tabs.length;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          }

          if (event.key === 'Home') {
            nextIndex = 0;
          }

          if (event.key === 'End') {
            nextIndex = tabs.length - 1;
          }

          const nextTab = tabs[nextIndex];

          activate(nextTab.dataset.zsqTab);
          nextTab.focus();
        });
      });

      const activeTab =
        tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];

      if (activeTab) {
        activate(activeTab.dataset.zsqTab);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    init();
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();